export default __webpack_public_path__ + "static/media/lightModeLogo.614601b4.png";